import Humanize from 'humanize-plus';
export default function replaceAndCapitalizeString(string) {
  var replaceThis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
  var withThis = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ' ';
  return Humanize.capitalizeAll(string.replace(new RegExp(replaceThis, 'g'), withThis));
}
//# sourceMappingURL=replaceAndCapitalizeString.js.map